import { render, staticRenderFns } from "./TablePriceItem.vue?vue&type=template&id=d246a18e"
import script from "./TablePriceItem.vue?vue&type=script&lang=js"
export * from "./TablePriceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports